import { ExportColumnInfo } from "./export-column-info";

export class ExportDataRequest {
  fileName?: string;
  fileType?: string;
  columns?: ExportColumnInfo[];
  data?: any[];
  isLandscape?: boolean;
  title?: string;
  customerId?: number;
  employeeId?: number;
  supplierId?: number;
  isDateActive?: Boolean;
  startDate?: Date;
  endDate?: Date;
  currencyCode?: string;
}
